import {
  PRESUPUESTADOR_CLEAR_BONIFICATION_TAKING_CAR_SUCCESS,
  } from '../constants';
  

  export function reducer(state, action) {
      if (action.type === PRESUPUESTADOR_CLEAR_BONIFICATION_TAKING_CAR_SUCCESS){
          return {
              ...state,
              entregaUsados: action.data.entregaUsados
          }
      }
      else {
          return state
      }
  }